// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  overflow-x: auto !important;
}
#container {
  padding: 25px;
}
.btn,
.btn-flat,
.btn-small,
.btn-large {
  font-family: Lato, "Helvetica Neue", Arial, Helvetica, sans-serif !important;
}
.modal-user .full_name {
  display: block;
}
.modal-user .user_group {
  display: inline-block;
  margin-top: 5px;
  border-radius: 12px;
  background: #dbd9d9;
  padding: 3px 10px;
  font-size: 12px;
  margin-left: -5px;
}
#alluser-content #btn-clear {
  float: right;
  color: #000;
  margin-left: 15px;
}
#alluser-content #btn-search {
  float: right;
  background-color: #1565c0;
}
#alluser-content.inner-container .filter-inputs {
  display: grid;
  grid-template-columns: auto auto auto;
  grid-gap: 10px;
}

#btn-edit-mode {
  background-color: #1565c0;
}
#btn-edit-mode:hover {
  background-color: #4fc3f7;
}
#btn-edit-mode:active {
  background-color: #4fc3f7;
}
/*#btn-edit-mode:focus{background-color: #4fc3f7;}*/
.textcolor-green {
  color: #26a69a;
}
.select-helper-text {
  color: red;
  text-align: left;
  font-size: 12px;
  float: left;
  padding: 0 12px;
}
#btn-select-limit-row {
  float: right;
  width: 100px;
  border: 1px solid #ddd;
  margin-right: 15px;
  font-weight: normal;
}
#btn-select-limit-row .input-field {
  margin-top: 0;
  margin-bottom: 0;
  padding: 0;
}
#btn-select-limit-row input:not(.browser-default) {
  border-bottom: none !important;
}
#btn-select-limit-row .select-wrapper input.select-dropdown {
  margin: 0;
  padding-left: 0.75rem;
}
#btn-select-limit-row .select-wrapper input.select-dropdown {
  height: 36px;
  line-height: 36px;
}
.btn-delete-single-item .material-icons {
  font-size: 1.8rem;
  color: red;
}
.btn-delete-single-item {
  cursor: pointer;
}
.modal-content strong {
  line-height: 3rem;
  height: 3rem;
  padding-left: 0 !important;
}
.modal-content .row {
  margin-bottom: 5px;
}
.modal-content h4 {
  text-transform: uppercase;
  font-size: 2rem;
  font-weight: 500;
  margin-bottom: 30px;
  margin-top: 5px;
}
th {
  padding-top: 0px;
  text-transform: uppercase;
}
th:not(.th-holiday-name) {
  width: 120px;
}
.th-delete,
.th-bulk-action {
  text-align: center;
}
td {
  padding: 10px 5px;
}
ul.dropdown-content {
  max-height: 400px !important;
  top: 46px !important;
  width: auto !important;
  min-width: 100% !important;
}
.modal-content ul.dropdown-content {
  max-height: 300px !important;
}
#dropdown-bulk-action li a {
  font-size: 14px;
  text-align: center;
}
.td-edit-mode {
  position: relative;
}
#btn-create-new {
  position: relative;
  float: right;
  margin-left: 15px;
}
.grid-container,
.filter-inputs {
  display: grid;
  grid-template-columns: auto auto auto auto auto auto;
  grid-gap: 10px;
}
.grid-container > div,
.filter-input-field {
  text-align: center;
  padding: 10px 0;
}
.filter-inputs.row {
  margin-bottom: 0px;
}
.filter-input-field .col {
  padding-top: 0px;
  padding-bottom: 0px;
  width: 100%;
}
#filter-submit {
  line-height: 5rem;
  margin: 0 5px;
  text-align: right;
}
#btn-filter {
  margin-right: 8px;
  padding: 0 10px;
}
#btn-clear-filter {
  padding: 0 10px;
}
#filter-search {
  padding-bottom: 10px;
}
#filter-search .input-field > label {
  color: #5a5a5a !important;
}
.filter-date {
  width: auto;
  max-width: 160px;
}
#form-filter-search input:not(.browser-default) {
  font-size: 14px;
}
#title-content {
  text-transform: uppercase;
  font-weight: 500;
  font-size: 20px;
  margin-top: 30px;
}
#btn-open-modal-create-calendar,
#btn-open-modal-create-item,
.btn-open-modal {
  color: #2196f3 !important;
  font-weight: normal;
}
.modal-close {
  color: red;
}
#modal-delete-item button {
  text-transform: none;
}
#modal-create-item,
#modal-create-calendar,
#modal-delete-item {
  max-height: 600px;
  max-width: 600px;
}
#modal-edit-calendar {
  width: 85%;
  max-height: none;
}
input:not(.browser-default):not(.no-default) {
  border-bottom: 1px solid #9e9e9e6e !important;
}
.total-text {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  margin: 0px 5px;
  margin-bottom: 20px;
}
#save-content {
  position: absolute;
  right: 10px;
  top: -12px;
}
#save-status {
  padding: 8px 20px;
  margin: 0px 14px;
}
.table-pagination {
  text-align: center;
  margin-top: 20px;
}
.pagination li.active {
  background-color: #40c4ff !important;
}
.modal-done-text {
  margin: 20px 0px;
  font-size: 20px;
  /* font-weight: 500; */
  color: green;
}
.modal-error-text {
  display: inline-block;
  margin-right: 15px;
  font-size: 15px;
  height: 36px;
  color: red;
  line-height: 36px;
  font-weight: 500;
}
/*@media only screen and (max-width: 800px) {
    .filter-inputs {
        grid-template-columns: auto auto auto;
    }
    #filter-submit {
        text-align: left;
    }
    .filter-date {
        width: auto;
        max-width: none;
    }
}*/

.filter-input-field,
.grid-container > div {
  text-align: center;
  padding: 10px 0;
}

#form-filter .filter-input-field.select {
  position: relative;
  margin-top: 0px;
}

.btn-select-all .select-all,
.btn-select-all .select-none {
  float: left;
  text-decoration: underline;
  font-size: 12px;
  cursor: pointer;
}

.btn-select-all {
  position: absolute;
  top: 7px;
  right: 12px;
  /*right: 5px;*/
}

.inner-container th .detail {
  color: red;
  font-size: 12px;
  text-transform: none;
  font-weight: normal;
  line-height: 14px;
}
.red-text {
  color: red !important;
}
.inner-container #table-total {
  height: 40px;
  margin-bottom: 10px;
}
#content-assign_days .title {
  text-align: right;
  line-height: 30px;
}
#content-assign_days {
  margin-top: 25px;
}
.inner-container .dropdown-content li > a,
.inner-container .dropdown-content li > span {
  font-size: 14px;
  text-transform: none;
  padding: 10px 12px;
  font-weight: normal;
  color: #5a5a5a;
}
.inner-container .th-bulk-action .dropdown-trigger {
  font-size: 12px !important;
  padding: 0 5px !important;
}
.inner-container .th-bulk-action {
  position: relative;
}
.inner-container .inp-assign-disable-expired {
  border: 2px solid #bf4848 !important;
  height: 30px !important;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  text-align: center;
  color: #9e9e9e;
  background-color: #eee !important;
  font-size: 14px !important;
  max-width: 60px;
  min-width: 60px;
}
.inner-container .inp-assign-disable {
  border: 2px solid #d1d1d1 !important;
  height: 30px !important;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  text-align: center;
  color: #9e9e9e;
  background-color: #eee !important;
  font-size: 14px !important;
  max-width: 60px;
  min-width: 60px;
}
.inner-container .inp-assign,
.modal-inp-assign {
  border: 2px solid #2b988e !important;
  height: 30px !important;
  margin-bottom: 0px !important;
  padding-bottom: 0px !important;
  text-align: center;
  font-size: 14px !important;
  max-width: 60px;
  min-width: 60px;
}
.inner-container th {
  font-size: 12px;
}
.inner-container .btn-delete,
.inner-container .btn-check {
  padding-right: 8px;
  padding-left: 8px;
}
.inner-container .btn-view-calendar .material-icons {
  color: #000;
  margin-left: 8px;
  font-size: 21px;
  line-height: 38px;
}
.inner-container .btn-view-calendar {
  float: right;
  margin-left: 5px;
  font-size: 13px;
  text-transform: none;
  padding-left: 5px;
  padding-right: 5px;
}
.inner-container .btn-top-right .material-icons {
  color: #000;
  margin-left: 8px;
  font-size: 20px;
  line-height: 38px;
}
.inner-container .btn-top-right {
  float: right;
  margin-left: 5px;
  font-size: 13px;
  text-transform: none;
  padding-left: 5px;
  padding-right: 5px;
}
.inner-container .image-circle i {
  font-size: 36px;
  margin-left: auto;
}
.inner-container .th-view,
.inner-container .th-change {
  max-width: 70px;
}
.inner-container .th-status {
  max-width: 100px;
  min-width: 100px;
}
.inner-container #main-content {
  padding-top: 0px;
  position: relative;
}
.inner-container #top-content {
  border-bottom: 2px dashed #ece7e7;
  margin-bottom: 25px;
}
.inner-container #main-btn {
  /*border-bottom: 2px dashed #ece7e7;
    padding-bottom: 18px;*/
  position: absolute;
  top: -120px;
  right: 10px;
}
.text-center {
  text-align: center;
}
.text-left {
  text-align: left;
}
.inner-container .td-photo {
  height: 65px;
  position: relative;
  min-width: 56px;
}
.inner-container .image-circle {
  width: 86px;
  height: 86px;
  position: absolute;
  top: 4px;
  left: 50%;
  margin-left: -28px;
  overflow: hidden;
  display: flex;
  justify-content: center;
}
.inner-container .select-helper-text:not(".input") {
  margin-top: -10px;
}
.inner-container .select-helper-text.input {
  margin-top: -18px;
}
.inner-container #form-filter {
  padding: 0;
}
.inner-container #btn-select-limit-row .input-field {
  margin-bottom: 0px;
}
.inner-container .input-field {
  margin-top: 0px;
  margin-bottom: 1rem;
}
/*.inner-container .select-wrapper .caret {
    fill: #27766f;
}*/
.inner-container .filter-input-field.select .col {
  border: 2px solid #2b988e;
  border-radius: 11px;
}
.inner-container .dropdown-content li {
  min-height: auto;
}
.inner-container .dropdown-content li > a,
.inner-container .dropdown-content li > span {
  line-height: 20px;
  padding: 10px 16px;
}
.inner-container .input-field > label,
.inner-container
  .input-field
  > input[type="date"]:not(.browser-default)
  + label {
  color: #27766f;
}
.inner-container
  input[type="text"]:not(.browser-default):not(.inp-assign):not(
    .inp-assign-disable
  ):not(.select-dropdown):not(.inp-assign-disable-expired),
.inner-container input[type="date"]:not(.browser-default),
input[type="text"]:not(.modal-inp-assign) {
  font-size: 14px;
  border-bottom: 2px solid #2b988e;
  color: #000000;
}
.inner-container [type="checkbox"] + span:not(.lever) {
  height: 22px;
  line-height: 22px;
  font-size: 14px;
}
.inner-container .select-wrapper input.select-dropdown {
  font-size: 14px;
  border-bottom: 0px solid red !important;
  margin-bottom: 0px;
  color: #000000;
}

.content-req #btn-resend {
  border-radius: 25px;
  min-width: 130px;
}

.content-req#content-req-resend {
  text-align: center;
  margin-top: 15px;
}
.content-req .inactive {
  color: #f23030;
}
.content-req .active {
  color: #6ed8bd;
}
#content-req-file img {
  max-height: 100px;
  border-radius: 8px;
  border: 1px solid #26a69a;
}
.content-req .PD,
.content-req .RQ,
.content-req .OK {
  color: #fb8c00;
}
.content-req .CC {
  color: #f23030;
}
.content-req .RJ {
  color: #f23030;
}
.content-req .AP {
  color: #6ed8bd;
}
#table-content .pagination li.active {
  background-color: #26a69a !important;
}
.content-req .file-upload .file-path {
  height: 36px;
  width: 100%;
  line-height: 35px;
  font-size: 12px;
}
.content-req .file-upload .btn-upload {
  background: #fff;
  color: #26a69a;
  border: 2px solid #26a69a;
  border-radius: 15px;
  height: 36px;
  line-height: 33px;
}
.content-req .desc-2 {
  padding-left: 0px;
}
.content-req .dropdown-content li > a,
.content-req .dropdown-content li > span {
  font-size: 14px;
  line-height: 17px;
  padding: 9px 16px;
  color: #5a5a5a;
}
.content-req .dropdown-content li {
  min-height: 34px;
}
.content-req .select-wrapper input.select-dropdown {
  height: 100%;
  width: 100%;
  font-size: 14px;
}
.content-req input[type="date"],
.content-req input[type="time"] {
  padding: 0px;
  height: 33px;
  min-height: auto;
  font-size: 14px;
}
.content-req .input-field {
  padding: 0px;
}
.inp-req {
  height: 33px;
  padding: 5px 0px;
  min-height: auto;
  font-size: 14px;
}
.inp-title {
  padding-top: 5px;
  line-height: 18px;
  min-height: 33px;
  height: auto;
  font-size: 14px;
}
#inp-req-reason {
  height: 30px;
  padding: 5px 0px;
  min-height: auto;
  font-size: 14px;
}
#content-view-top .error {
  color: red;
  font-size: 12px;
  margin-top: 8px;
  display: block;
  line-height: 15px;
}
#content-view-top .name {
  display: block;
}
#content-req-reason .title {
  padding-top: 5px;
}
#content-req-reason .input-field {
  padding: 0px;
}
.image-circle.active {
  border: 3px solid #63e811;
}
.image-circle i {
  font-size: 42px;
  margin-top: 8px;
  margin-left: 8px;
}
.image-circle {
  border-radius: 50%;
  display: block;
  height: 86px;
  width: 86px;
  border: 1px solid #ddd;
  margin-left: 8px;
}
#content-view-top .desc {
  margin-top: 12px;
}
#content-view-top {
  height: 80px;
  margin-bottom: 15px;
}
/*#modal-user-view .modal-content-outer {
    position: absolute;
    height: calc(100% - 45px);
    max-height: 100%;
    width: 100%;
    top: 45px;
    overflow-y: auto;
}
#modal-user-view .modal-content-inner {
    padding: 15px 25px;
}
#modal-user-view .modal-content h4 {
    top: 0px;
    margin: 0;
    font-size: 1.3rem;
    padding: 0 25px;
    height: 45px;
    line-height: 45px;
    border-bottom: 1px solid rgba(0,0,0,0.1);
}*/
#modal-warning-content {
  position: relative;
}
#modal-warning-content i {
  position: absolute;
  top: 0;
  left: 0;
  font-size: 3.2rem;
  color: #fed62b;
}
#modal-warning-content .text {
  color: #c01616;
  margin-left: 60px;
  font-size: 18px;
  padding-top: 5px;
}
#modal-error-content {
  position: relative;
}
#modal-error-content a {
  position: absolute;
  top: 0;
  left: 0;
}
#modal-error-content .text {
  color: #c01616;
  margin-left: 60px;
  font-size: 18px;
  padding-top: 5px;
}
#modal-done-content {
  position: relative;
}
#modal-done-content a {
  position: absolute;
  top: 0;
  left: 0;
}
#modal-done-content .text {
  color: #26a69a;
  margin-left: 60px;
  font-size: 18px;
  padding-top: 5px;
}
.modal-user .modal-footer-bottom-2 .modal-error-text {
}
.modal-user .modal-footer-bottom-2 .btn-right-2 {
  padding-left: 8px;
  padding-right: 8px;
  text-transform: none;
  margin: 0;
  margin-left: 8px;
}
.modal-user .modal-footer-bottom-2 .btn-right-1 {
  padding-left: 8px;
  padding-right: 8px;
  text-transform: none;
}
.modal-user .modal-footer-bottom-2 .btn-right {
  float: right;
  margin-top: 7px;
}
.modal-user .modal-footer-bottom .modal-error-text {
  padding-top: 7px;
  font-weight: normal;
  font-size: 13px;
  line-height: 14px;
  display: block;
  margin-right: 90px;
}
.modal-user .modal-footer-bottom button {
  height: 32px;
  line-height: 32px;
  font-size: 1rem;
  position: absolute;
  top: 9px;
  right: 30px;
}
.modal-user .modal-footer-bottom,
.modal-user .modal-footer-bottom-2 {
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 50px;
  padding: 0px 25px;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
}
.modal-user-footer .text-error {
  padding: 25px;
}
.modal-user-footer .modal-content {
  padding: 0px;
}
.modal-user .modal-content-outer {
  position: absolute;
  height: calc(100% - 50px);
  width: 100%;
  bottom: 50px;
  overflow-y: auto;
  padding: 15px 25px;
}
.modal-close i {
  font-size: 2rem;
}
.modal-user .modal-content h4 {
  display: none;
}
.modal-user .modal-footer .header {
  font-size: 1.3rem;
  padding: 0 25px;
  height: 50px;
  line-height: 50px;
  float: left;
  text-transform: uppercase;
  font-weight: 600;
}
.modal-user .modal-close {
  margin: 8px 0px;
}
.modal-user .modal-content {
  position: absolute;
  height: calc(100% - 50px);
  max-height: 100%;
  width: 100%;
  top: 50px;
  overflow-y: auto;
}
.modal-user .modal-footer {
  position: absolute;
  top: 0;
  height: 50px;
  padding: 0px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.1);
}
.modal-user {
  max-width: 850px;
  border-radius: 16px;
  width: 85%;
  height: 70%;
  /*height: 50% !important;*/
  border: 3px solid #37bdb0;
  max-height: 500px;
}
.content-req .title,
.content-req .desc {
  line-height: 18px;
  min-height: 33px;
  height: auto;
}
.text-error {
  color: red;
  font-size: 14px;
}
#table-total {
  font-size: 12px;
  font-weight: 500;
  text-transform: uppercase;
  margin-bottom: 20px;
}
#table-alluser .btn-check i {
  font-size: 2rem;
}
#table-alluser .btn-delete i {
  font-size: 2.2rem;
}
#table-alluser .btn-delete {
  display: inline-block;
  padding-left: 7px;
  padding-right: 7px;
}
#table-alluser .btn-edit i {
  font-size: 2rem;
}
#table-alluser .btn-edit {
  display: inline-block;
  padding-left: 7px;
  padding-right: 7px;
}
#table-alluser .btn-view i {
  margin-top: 2px;
  margin-bottom: 2px;
  font-size: 24px;
  line-height: unset;
  display: inline;
  color: #fff;
}
#table-alluser .btn-view {
  border: 1px solid #ddd;
  border-radius: 5px;
  display: inline-block;
  margin: 0 auto;
  padding: 0px 5px;
  background: #4f4949;
  height: 35px;
}
#table-alluser .OK {
  border: 2px solid #fb8c00;
  background-color: #fb8c00;
  color: #fff;
}
#table-alluser .PD,
#table-alluser .RQ {
  border: 2px solid #fb8c00;
  background-color: #fff;
  color: #fb8c00;
}
#table-alluser .CC {
  border: 2px solid #f23030;
  background-color: #fff;
  color: #f23030;
}
#table-alluser .N {
  border: 2px solid #726868;
  background-color: #fff;
  color: #726868;
}
#table-alluser .Y {
  border: 2px solid #6ed8bd;
  background-color: #6ed8bd;
  color: #fff;
}
#table-alluser .active-text {
  border-radius: 12px;
  padding: 2px 0px;
  font-size: 13px;
  font-weight: 500;
  max-width: 110px;
  margin: 0 auto;
}
#table-alluser .total {
  color: #20a684;
}
#table-alluser .small-text {
  display: block;
  font-size: 11px;
  color: #20a684;
}
#table-alluser .text {
  display: block;
  font-size: 13px;
}
#table-alluser th,
#table-alluser td {
  text-align: center;
  vertical-align: top;
}
#main-content .title {
  text-transform: uppercase;
  font-size: 18px;
  font-weight: bold;
}
#main-content {
  padding: 15px 20px;
}
.top-sub-bottom #btn-request-compensation {
  float: right;
  background: #fff;
  border: 2px solid #26a69a;
  color: #26a69a;
  text-transform: none;
  line-height: 30px;
  padding-left: 8px;
  padding-right: 8px;
  margin-left: 12px;
}
.top-sub-bottom #btn-create-new {
  float: right;
  text-transform: none;
  line-height: 30px;
  padding-left: 8px;
  padding-right: 8px;
  margin-left: 0px;
}
.top-sub-bottom div:nth-child(2) {
  float: left;
  margin-right: 15px;
  line-height: 36px;
}
.top-sub-bottom div:nth-child(1) {
  float: left;
  margin-right: 15px;
  line-height: 36px;
}
.top-sub-bottom .title {
  font-weight: bold;
  margin-right: 5px;
}
.top-sub-bottom {
  padding: 0px 20px;
}
#top-sub-box-compensation {
  background-color: #f1eee5;
}
#top-sub-box-balance {
  background-color: #f2f0d5;
}
#top-sub-box-previous {
  background-color: #ffd862;
}
#top-sub-box-annual {
  background-color: #a6bf4b;
}

.top-sub-box .color-red {
  color: #d40e0e;
}

.top-sub-box #top-sub-box-balance .text-day .sub-title {
  display: inline-block;
}

.top-sub-box #top-sub-box-balance .text-hour .sub-title {
  display: inline-block;
}

.top-sub-box .desc {
  padding: 8px 0px;
  font-size: 11px;
}
.top-sub-box .text-hour {
  font-size: 11px;
  margin-top: -6px;
  height: 15px;
}
.top-sub-box .text-day {
  font-size: 20px;
  font-weight: bold;
}
.top-sub-box span {
  display: block;
}
.top-sub-box .textcolor-expired {
  color: #e40d0d;
}
.top-sub-box .textcolor {
  color: #000;
}
.top-sub-box div {
  padding-top: 15px;
  padding-bottom: 5px;
  text-align: center;
  border-radius: 12px;
  margin: 0px;
}
.btn {
  text-transform: none !important;
}
.filter-input-field .label {
  text-align: left;
  display: block;
  padding: 0 0.75rem;
  color: #5a5a5a;
}
.filter-input-field.select .search {
  height: auto;
}
.ui.selection.active.dropdown {
  border-color: #26a69a !important;
}
.ui.selection.active.dropdown .menu {
  border-color: #26a69a !important;
}
.ui.label {
  background-color: #eaeaea !important;
}
.ui.disabled.search {
  opacity: 0.75 !important;
}
.ui.fluid.dropdown {
  display: inline-block !important;
}
.alluser-dropdown.ui.selection.dropdown {
  padding-top: 4px !important;
  padding-bottom: 4px !important;
}


/* .dropdown-menu-max-height {
  max-height: 200px;
  overflow-y: auto;
} */

.menu-scrollable {
    max-height: 120px;
    overflow-y: auto;
}


  
`, "",{"version":3,"sources":["webpack://./src/assets/styles/container/style.css"],"names":[],"mappings":"AAAA;EACE,2BAA2B;AAC7B;AACA;EACE,aAAa;AACf;AACA;;;;EAIE,4EAA4E;AAC9E;AACA;EACE,cAAc;AAChB;AACA;EACE,qBAAqB;EACrB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,yBAAyB;AAC3B;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,cAAc;AAChB;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA,mDAAmD;AACnD;EACE,cAAc;AAChB;AACA;EACE,UAAU;EACV,gBAAgB;EAChB,eAAe;EACf,WAAW;EACX,eAAe;AACjB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,sBAAsB;EACtB,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,gBAAgB;EAChB,UAAU;AACZ;AACA;EACE,8BAA8B;AAChC;AACA;EACE,SAAS;EACT,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,UAAU;AACZ;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;EACjB,YAAY;EACZ,0BAA0B;AAC5B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;AACA;;EAEE,kBAAkB;AACpB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,4BAA4B;EAC5B,oBAAoB;EACpB,sBAAsB;EACtB,0BAA0B;AAC5B;AACA;EACE,4BAA4B;AAC9B;AACA;EACE,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;AACnB;AACA;;EAEE,aAAa;EACb,oDAAoD;EACpD,cAAc;AAChB;AACA;;EAEE,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,aAAa;EACb,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;EACE,oBAAoB;AACtB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,WAAW;EACX,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;AACA;;;EAGE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,UAAU;AACZ;AACA;EACE,oBAAoB;AACtB;AACA;;;EAGE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,gBAAgB;AAClB;AACA;EACE,6CAA6C;AAC/C;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,eAAe;EACf,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,WAAW;EACX,UAAU;AACZ;AACA;EACE,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,YAAY;AACd;AACA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,UAAU;EACV,iBAAiB;EACjB,gBAAgB;AAClB;AACA;;;;;;;;;;;EAWE;;AAEF;;EAEE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,iBAAiB;AACnB;AACA;EACE,qBAAqB;AACvB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,eAAe;EACf,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;AACA;EACE,0BAA0B;EAC1B,yBAAyB;AAC3B;AACA;EACE,kBAAkB;AACpB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;AACA;EACE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,iCAAiC;EACjC,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;AACA;;EAEE,oCAAoC;EACpC,uBAAuB;EACvB,6BAA6B;EAC7B,8BAA8B;EAC9B,kBAAkB;EAClB,0BAA0B;EAC1B,eAAe;EACf,eAAe;AACjB;AACA;EACE,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;;EAEE,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,iCAAiC;EACjC,mBAAmB;AACrB;AACA;EACE;0BACwB;EACxB,kBAAkB;EAClB,WAAW;EACX,WAAW;AACb;AACA;EACE,kBAAkB;AACpB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,UAAU;AACZ;AACA;EACE,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,mBAAmB;AACrB;AACA;;EAEE;AACF;EACE,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,gBAAgB;AAClB;AACA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;AACA;;;;;EAKE,cAAc;AAChB;AACA;;;;;;EAME,eAAe;EACf,gCAAgC;EAChC,cAAc;AAChB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,eAAe;EACf,uCAAuC;EACvC,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;AACA;;;EAGE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,oCAAoC;AACtC;AACA;EACE,YAAY;EACZ,WAAW;EACX,iBAAiB;EACjB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,yBAAyB;EACzB,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;;EAEE,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;AACA;;EAEE,YAAY;EACZ,YAAY;EACZ,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,YAAY;AACd;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,UAAU;EACV,eAAe;EACf,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;AACd;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,cAAc;EACd,YAAY;EACZ,WAAW;EACX,sBAAsB;EACtB,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,mBAAmB;AACrB;AACA;;;;;;;;;;;;;;;;;;;EAmBE;AACF;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,iBAAiB;EACjB,cAAc;AAChB;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;AACT;AACA;EACE,cAAc;EACd,iBAAiB;EACjB,eAAe;EACf,gBAAgB;AAClB;AACA;AACA;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;EACpB,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,oBAAoB;AACtB;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,kBAAkB;EAClB,QAAQ;EACR,WAAW;AACb;AACA;;EAEE,kBAAkB;EAClB,WAAW;EACX,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wCAAwC;AAC1C;AACA;EACE,aAAa;AACf;AACA;EACE,YAAY;AACd;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,aAAa;AACf;AACA;EACE,iBAAiB;EACjB,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,gBAAgB;AAClB;AACA;EACE,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;EACX,SAAS;EACT,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,MAAM;EACN,YAAY;EACZ,YAAY;EACZ,2CAA2C;AAC7C;AACA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,0BAA0B;EAC1B,yBAAyB;EACzB,iBAAiB;AACnB;AACA;;EAEE,iBAAiB;EACjB,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,UAAU;EACV,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,eAAe;AACjB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;AACjB;AACA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,eAAe;EACf,WAAW;AACb;AACA;EACE,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;EACrB,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA;;EAEE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;AACA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,WAAW;AACb;AACA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;EACf,cAAc;AAChB;AACA;EACE,cAAc;EACd,eAAe;AACjB;AACA;;EAEE,kBAAkB;EAClB,mBAAmB;AACrB;AACA;EACE,yBAAyB;EACzB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,kBAAkB;AACpB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,yBAAyB;EACzB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,kBAAkB;EAClB,iBAAiB;AACnB;AACA;EACE,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,iBAAiB;AACnB;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;AACA;EACE,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;AACA;EACE,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,cAAc;AAChB;AACA;EACE,cAAc;AAChB;AACA;EACE,WAAW;AACb;AACA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,WAAW;AACb;AACA;EACE,+BAA+B;AACjC;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,cAAc;AAChB;AACA;EACE,YAAY;AACd;AACA;EACE,gCAAgC;AAClC;AACA;EACE,gCAAgC;AAClC;AACA;EACE,oCAAoC;AACtC;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,gCAAgC;AAClC;AACA;EACE,2BAA2B;EAC3B,8BAA8B;AAChC;;;AAGA;;;GAGG;;AAEH;IACI,iBAAiB;IACjB,gBAAgB;AACpB","sourcesContent":["body {\r\n  overflow-x: auto !important;\r\n}\r\n#container {\r\n  padding: 25px;\r\n}\r\n.btn,\r\n.btn-flat,\r\n.btn-small,\r\n.btn-large {\r\n  font-family: Lato, \"Helvetica Neue\", Arial, Helvetica, sans-serif !important;\r\n}\r\n.modal-user .full_name {\r\n  display: block;\r\n}\r\n.modal-user .user_group {\r\n  display: inline-block;\r\n  margin-top: 5px;\r\n  border-radius: 12px;\r\n  background: #dbd9d9;\r\n  padding: 3px 10px;\r\n  font-size: 12px;\r\n  margin-left: -5px;\r\n}\r\n#alluser-content #btn-clear {\r\n  float: right;\r\n  color: #000;\r\n  margin-left: 15px;\r\n}\r\n#alluser-content #btn-search {\r\n  float: right;\r\n  background-color: #1565c0;\r\n}\r\n#alluser-content.inner-container .filter-inputs {\r\n  display: grid;\r\n  grid-template-columns: auto auto auto;\r\n  grid-gap: 10px;\r\n}\r\n\r\n#btn-edit-mode {\r\n  background-color: #1565c0;\r\n}\r\n#btn-edit-mode:hover {\r\n  background-color: #4fc3f7;\r\n}\r\n#btn-edit-mode:active {\r\n  background-color: #4fc3f7;\r\n}\r\n/*#btn-edit-mode:focus{background-color: #4fc3f7;}*/\r\n.textcolor-green {\r\n  color: #26a69a;\r\n}\r\n.select-helper-text {\r\n  color: red;\r\n  text-align: left;\r\n  font-size: 12px;\r\n  float: left;\r\n  padding: 0 12px;\r\n}\r\n#btn-select-limit-row {\r\n  float: right;\r\n  width: 100px;\r\n  border: 1px solid #ddd;\r\n  margin-right: 15px;\r\n  font-weight: normal;\r\n}\r\n#btn-select-limit-row .input-field {\r\n  margin-top: 0;\r\n  margin-bottom: 0;\r\n  padding: 0;\r\n}\r\n#btn-select-limit-row input:not(.browser-default) {\r\n  border-bottom: none !important;\r\n}\r\n#btn-select-limit-row .select-wrapper input.select-dropdown {\r\n  margin: 0;\r\n  padding-left: 0.75rem;\r\n}\r\n#btn-select-limit-row .select-wrapper input.select-dropdown {\r\n  height: 36px;\r\n  line-height: 36px;\r\n}\r\n.btn-delete-single-item .material-icons {\r\n  font-size: 1.8rem;\r\n  color: red;\r\n}\r\n.btn-delete-single-item {\r\n  cursor: pointer;\r\n}\r\n.modal-content strong {\r\n  line-height: 3rem;\r\n  height: 3rem;\r\n  padding-left: 0 !important;\r\n}\r\n.modal-content .row {\r\n  margin-bottom: 5px;\r\n}\r\n.modal-content h4 {\r\n  text-transform: uppercase;\r\n  font-size: 2rem;\r\n  font-weight: 500;\r\n  margin-bottom: 30px;\r\n  margin-top: 5px;\r\n}\r\nth {\r\n  padding-top: 0px;\r\n  text-transform: uppercase;\r\n}\r\nth:not(.th-holiday-name) {\r\n  width: 120px;\r\n}\r\n.th-delete,\r\n.th-bulk-action {\r\n  text-align: center;\r\n}\r\ntd {\r\n  padding: 10px 5px;\r\n}\r\nul.dropdown-content {\r\n  max-height: 400px !important;\r\n  top: 46px !important;\r\n  width: auto !important;\r\n  min-width: 100% !important;\r\n}\r\n.modal-content ul.dropdown-content {\r\n  max-height: 300px !important;\r\n}\r\n#dropdown-bulk-action li a {\r\n  font-size: 14px;\r\n  text-align: center;\r\n}\r\n.td-edit-mode {\r\n  position: relative;\r\n}\r\n#btn-create-new {\r\n  position: relative;\r\n  float: right;\r\n  margin-left: 15px;\r\n}\r\n.grid-container,\r\n.filter-inputs {\r\n  display: grid;\r\n  grid-template-columns: auto auto auto auto auto auto;\r\n  grid-gap: 10px;\r\n}\r\n.grid-container > div,\r\n.filter-input-field {\r\n  text-align: center;\r\n  padding: 10px 0;\r\n}\r\n.filter-inputs.row {\r\n  margin-bottom: 0px;\r\n}\r\n.filter-input-field .col {\r\n  padding-top: 0px;\r\n  padding-bottom: 0px;\r\n  width: 100%;\r\n}\r\n#filter-submit {\r\n  line-height: 5rem;\r\n  margin: 0 5px;\r\n  text-align: right;\r\n}\r\n#btn-filter {\r\n  margin-right: 8px;\r\n  padding: 0 10px;\r\n}\r\n#btn-clear-filter {\r\n  padding: 0 10px;\r\n}\r\n#filter-search {\r\n  padding-bottom: 10px;\r\n}\r\n#filter-search .input-field > label {\r\n  color: #5a5a5a !important;\r\n}\r\n.filter-date {\r\n  width: auto;\r\n  max-width: 160px;\r\n}\r\n#form-filter-search input:not(.browser-default) {\r\n  font-size: 14px;\r\n}\r\n#title-content {\r\n  text-transform: uppercase;\r\n  font-weight: 500;\r\n  font-size: 20px;\r\n  margin-top: 30px;\r\n}\r\n#btn-open-modal-create-calendar,\r\n#btn-open-modal-create-item,\r\n.btn-open-modal {\r\n  color: #2196f3 !important;\r\n  font-weight: normal;\r\n}\r\n.modal-close {\r\n  color: red;\r\n}\r\n#modal-delete-item button {\r\n  text-transform: none;\r\n}\r\n#modal-create-item,\r\n#modal-create-calendar,\r\n#modal-delete-item {\r\n  max-height: 600px;\r\n  max-width: 600px;\r\n}\r\n#modal-edit-calendar {\r\n  width: 85%;\r\n  max-height: none;\r\n}\r\ninput:not(.browser-default):not(.no-default) {\r\n  border-bottom: 1px solid #9e9e9e6e !important;\r\n}\r\n.total-text {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  margin: 0px 5px;\r\n  margin-bottom: 20px;\r\n}\r\n#save-content {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: -12px;\r\n}\r\n#save-status {\r\n  padding: 8px 20px;\r\n  margin: 0px 14px;\r\n}\r\n.table-pagination {\r\n  text-align: center;\r\n  margin-top: 20px;\r\n}\r\n.pagination li.active {\r\n  background-color: #40c4ff !important;\r\n}\r\n.modal-done-text {\r\n  margin: 20px 0px;\r\n  font-size: 20px;\r\n  /* font-weight: 500; */\r\n  color: green;\r\n}\r\n.modal-error-text {\r\n  display: inline-block;\r\n  margin-right: 15px;\r\n  font-size: 15px;\r\n  height: 36px;\r\n  color: red;\r\n  line-height: 36px;\r\n  font-weight: 500;\r\n}\r\n/*@media only screen and (max-width: 800px) {\r\n    .filter-inputs {\r\n        grid-template-columns: auto auto auto;\r\n    }\r\n    #filter-submit {\r\n        text-align: left;\r\n    }\r\n    .filter-date {\r\n        width: auto;\r\n        max-width: none;\r\n    }\r\n}*/\r\n\r\n.filter-input-field,\r\n.grid-container > div {\r\n  text-align: center;\r\n  padding: 10px 0;\r\n}\r\n\r\n#form-filter .filter-input-field.select {\r\n  position: relative;\r\n  margin-top: 0px;\r\n}\r\n\r\n.btn-select-all .select-all,\r\n.btn-select-all .select-none {\r\n  float: left;\r\n  text-decoration: underline;\r\n  font-size: 12px;\r\n  cursor: pointer;\r\n}\r\n\r\n.btn-select-all {\r\n  position: absolute;\r\n  top: 7px;\r\n  right: 12px;\r\n  /*right: 5px;*/\r\n}\r\n\r\n.inner-container th .detail {\r\n  color: red;\r\n  font-size: 12px;\r\n  text-transform: none;\r\n  font-weight: normal;\r\n  line-height: 14px;\r\n}\r\n.red-text {\r\n  color: red !important;\r\n}\r\n.inner-container #table-total {\r\n  height: 40px;\r\n  margin-bottom: 10px;\r\n}\r\n#content-assign_days .title {\r\n  text-align: right;\r\n  line-height: 30px;\r\n}\r\n#content-assign_days {\r\n  margin-top: 25px;\r\n}\r\n.inner-container .dropdown-content li > a,\r\n.inner-container .dropdown-content li > span {\r\n  font-size: 14px;\r\n  text-transform: none;\r\n  padding: 10px 12px;\r\n  font-weight: normal;\r\n  color: #5a5a5a;\r\n}\r\n.inner-container .th-bulk-action .dropdown-trigger {\r\n  font-size: 12px !important;\r\n  padding: 0 5px !important;\r\n}\r\n.inner-container .th-bulk-action {\r\n  position: relative;\r\n}\r\n.inner-container .inp-assign-disable-expired {\r\n  border: 2px solid #bf4848 !important;\r\n  height: 30px !important;\r\n  margin-bottom: 0px !important;\r\n  padding-bottom: 0px !important;\r\n  text-align: center;\r\n  color: #9e9e9e;\r\n  background-color: #eee !important;\r\n  font-size: 14px !important;\r\n  max-width: 60px;\r\n  min-width: 60px;\r\n}\r\n.inner-container .inp-assign-disable {\r\n  border: 2px solid #d1d1d1 !important;\r\n  height: 30px !important;\r\n  margin-bottom: 0px !important;\r\n  padding-bottom: 0px !important;\r\n  text-align: center;\r\n  color: #9e9e9e;\r\n  background-color: #eee !important;\r\n  font-size: 14px !important;\r\n  max-width: 60px;\r\n  min-width: 60px;\r\n}\r\n.inner-container .inp-assign,\r\n.modal-inp-assign {\r\n  border: 2px solid #2b988e !important;\r\n  height: 30px !important;\r\n  margin-bottom: 0px !important;\r\n  padding-bottom: 0px !important;\r\n  text-align: center;\r\n  font-size: 14px !important;\r\n  max-width: 60px;\r\n  min-width: 60px;\r\n}\r\n.inner-container th {\r\n  font-size: 12px;\r\n}\r\n.inner-container .btn-delete,\r\n.inner-container .btn-check {\r\n  padding-right: 8px;\r\n  padding-left: 8px;\r\n}\r\n.inner-container .btn-view-calendar .material-icons {\r\n  color: #000;\r\n  margin-left: 8px;\r\n  font-size: 21px;\r\n  line-height: 38px;\r\n}\r\n.inner-container .btn-view-calendar {\r\n  float: right;\r\n  margin-left: 5px;\r\n  font-size: 13px;\r\n  text-transform: none;\r\n  padding-left: 5px;\r\n  padding-right: 5px;\r\n}\r\n.inner-container .btn-top-right .material-icons {\r\n  color: #000;\r\n  margin-left: 8px;\r\n  font-size: 20px;\r\n  line-height: 38px;\r\n}\r\n.inner-container .btn-top-right {\r\n  float: right;\r\n  margin-left: 5px;\r\n  font-size: 13px;\r\n  text-transform: none;\r\n  padding-left: 5px;\r\n  padding-right: 5px;\r\n}\r\n.inner-container .image-circle i {\r\n  font-size: 36px;\r\n  margin-left: auto;\r\n}\r\n.inner-container .th-view,\r\n.inner-container .th-change {\r\n  max-width: 70px;\r\n}\r\n.inner-container .th-status {\r\n  max-width: 100px;\r\n  min-width: 100px;\r\n}\r\n.inner-container #main-content {\r\n  padding-top: 0px;\r\n  position: relative;\r\n}\r\n.inner-container #top-content {\r\n  border-bottom: 2px dashed #ece7e7;\r\n  margin-bottom: 25px;\r\n}\r\n.inner-container #main-btn {\r\n  /*border-bottom: 2px dashed #ece7e7;\r\n    padding-bottom: 18px;*/\r\n  position: absolute;\r\n  top: -120px;\r\n  right: 10px;\r\n}\r\n.text-center {\r\n  text-align: center;\r\n}\r\n.text-left {\r\n  text-align: left;\r\n}\r\n.inner-container .td-photo {\r\n  height: 65px;\r\n  position: relative;\r\n  min-width: 56px;\r\n}\r\n.inner-container .image-circle {\r\n  width: 86px;\r\n  height: 86px;\r\n  position: absolute;\r\n  top: 4px;\r\n  left: 50%;\r\n  margin-left: -28px;\r\n  overflow: hidden;\r\n  display: flex;\r\n  justify-content: center;\r\n}\r\n.inner-container .select-helper-text:not(\".input\") {\r\n  margin-top: -10px;\r\n}\r\n.inner-container .select-helper-text.input {\r\n  margin-top: -18px;\r\n}\r\n.inner-container #form-filter {\r\n  padding: 0;\r\n}\r\n.inner-container #btn-select-limit-row .input-field {\r\n  margin-bottom: 0px;\r\n}\r\n.inner-container .input-field {\r\n  margin-top: 0px;\r\n  margin-bottom: 1rem;\r\n}\r\n/*.inner-container .select-wrapper .caret {\r\n    fill: #27766f;\r\n}*/\r\n.inner-container .filter-input-field.select .col {\r\n  border: 2px solid #2b988e;\r\n  border-radius: 11px;\r\n}\r\n.inner-container .dropdown-content li {\r\n  min-height: auto;\r\n}\r\n.inner-container .dropdown-content li > a,\r\n.inner-container .dropdown-content li > span {\r\n  line-height: 20px;\r\n  padding: 10px 16px;\r\n}\r\n.inner-container .input-field > label,\r\n.inner-container\r\n  .input-field\r\n  > input[type=\"date\"]:not(.browser-default)\r\n  + label {\r\n  color: #27766f;\r\n}\r\n.inner-container\r\n  input[type=\"text\"]:not(.browser-default):not(.inp-assign):not(\r\n    .inp-assign-disable\r\n  ):not(.select-dropdown):not(.inp-assign-disable-expired),\r\n.inner-container input[type=\"date\"]:not(.browser-default),\r\ninput[type=\"text\"]:not(.modal-inp-assign) {\r\n  font-size: 14px;\r\n  border-bottom: 2px solid #2b988e;\r\n  color: #000000;\r\n}\r\n.inner-container [type=\"checkbox\"] + span:not(.lever) {\r\n  height: 22px;\r\n  line-height: 22px;\r\n  font-size: 14px;\r\n}\r\n.inner-container .select-wrapper input.select-dropdown {\r\n  font-size: 14px;\r\n  border-bottom: 0px solid red !important;\r\n  margin-bottom: 0px;\r\n  color: #000000;\r\n}\r\n\r\n.content-req #btn-resend {\r\n  border-radius: 25px;\r\n  min-width: 130px;\r\n}\r\n\r\n.content-req#content-req-resend {\r\n  text-align: center;\r\n  margin-top: 15px;\r\n}\r\n.content-req .inactive {\r\n  color: #f23030;\r\n}\r\n.content-req .active {\r\n  color: #6ed8bd;\r\n}\r\n#content-req-file img {\r\n  max-height: 100px;\r\n  border-radius: 8px;\r\n  border: 1px solid #26a69a;\r\n}\r\n.content-req .PD,\r\n.content-req .RQ,\r\n.content-req .OK {\r\n  color: #fb8c00;\r\n}\r\n.content-req .CC {\r\n  color: #f23030;\r\n}\r\n.content-req .RJ {\r\n  color: #f23030;\r\n}\r\n.content-req .AP {\r\n  color: #6ed8bd;\r\n}\r\n#table-content .pagination li.active {\r\n  background-color: #26a69a !important;\r\n}\r\n.content-req .file-upload .file-path {\r\n  height: 36px;\r\n  width: 100%;\r\n  line-height: 35px;\r\n  font-size: 12px;\r\n}\r\n.content-req .file-upload .btn-upload {\r\n  background: #fff;\r\n  color: #26a69a;\r\n  border: 2px solid #26a69a;\r\n  border-radius: 15px;\r\n  height: 36px;\r\n  line-height: 33px;\r\n}\r\n.content-req .desc-2 {\r\n  padding-left: 0px;\r\n}\r\n.content-req .dropdown-content li > a,\r\n.content-req .dropdown-content li > span {\r\n  font-size: 14px;\r\n  line-height: 17px;\r\n  padding: 9px 16px;\r\n  color: #5a5a5a;\r\n}\r\n.content-req .dropdown-content li {\r\n  min-height: 34px;\r\n}\r\n.content-req .select-wrapper input.select-dropdown {\r\n  height: 100%;\r\n  width: 100%;\r\n  font-size: 14px;\r\n}\r\n.content-req input[type=\"date\"],\r\n.content-req input[type=\"time\"] {\r\n  padding: 0px;\r\n  height: 33px;\r\n  min-height: auto;\r\n  font-size: 14px;\r\n}\r\n.content-req .input-field {\r\n  padding: 0px;\r\n}\r\n.inp-req {\r\n  height: 33px;\r\n  padding: 5px 0px;\r\n  min-height: auto;\r\n  font-size: 14px;\r\n}\r\n.inp-title {\r\n  padding-top: 5px;\r\n  line-height: 18px;\r\n  min-height: 33px;\r\n  height: auto;\r\n  font-size: 14px;\r\n}\r\n#inp-req-reason {\r\n  height: 30px;\r\n  padding: 5px 0px;\r\n  min-height: auto;\r\n  font-size: 14px;\r\n}\r\n#content-view-top .error {\r\n  color: red;\r\n  font-size: 12px;\r\n  margin-top: 8px;\r\n  display: block;\r\n  line-height: 15px;\r\n}\r\n#content-view-top .name {\r\n  display: block;\r\n}\r\n#content-req-reason .title {\r\n  padding-top: 5px;\r\n}\r\n#content-req-reason .input-field {\r\n  padding: 0px;\r\n}\r\n.image-circle.active {\r\n  border: 3px solid #63e811;\r\n}\r\n.image-circle i {\r\n  font-size: 42px;\r\n  margin-top: 8px;\r\n  margin-left: 8px;\r\n}\r\n.image-circle {\r\n  border-radius: 50%;\r\n  display: block;\r\n  height: 86px;\r\n  width: 86px;\r\n  border: 1px solid #ddd;\r\n  margin-left: 8px;\r\n}\r\n#content-view-top .desc {\r\n  margin-top: 12px;\r\n}\r\n#content-view-top {\r\n  height: 80px;\r\n  margin-bottom: 15px;\r\n}\r\n/*#modal-user-view .modal-content-outer {\r\n    position: absolute;\r\n    height: calc(100% - 45px);\r\n    max-height: 100%;\r\n    width: 100%;\r\n    top: 45px;\r\n    overflow-y: auto;\r\n}\r\n#modal-user-view .modal-content-inner {\r\n    padding: 15px 25px;\r\n}\r\n#modal-user-view .modal-content h4 {\r\n    top: 0px;\r\n    margin: 0;\r\n    font-size: 1.3rem;\r\n    padding: 0 25px;\r\n    height: 45px;\r\n    line-height: 45px;\r\n    border-bottom: 1px solid rgba(0,0,0,0.1);\r\n}*/\r\n#modal-warning-content {\r\n  position: relative;\r\n}\r\n#modal-warning-content i {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  font-size: 3.2rem;\r\n  color: #fed62b;\r\n}\r\n#modal-warning-content .text {\r\n  color: #c01616;\r\n  margin-left: 60px;\r\n  font-size: 18px;\r\n  padding-top: 5px;\r\n}\r\n#modal-error-content {\r\n  position: relative;\r\n}\r\n#modal-error-content a {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n#modal-error-content .text {\r\n  color: #c01616;\r\n  margin-left: 60px;\r\n  font-size: 18px;\r\n  padding-top: 5px;\r\n}\r\n#modal-done-content {\r\n  position: relative;\r\n}\r\n#modal-done-content a {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n}\r\n#modal-done-content .text {\r\n  color: #26a69a;\r\n  margin-left: 60px;\r\n  font-size: 18px;\r\n  padding-top: 5px;\r\n}\r\n.modal-user .modal-footer-bottom-2 .modal-error-text {\r\n}\r\n.modal-user .modal-footer-bottom-2 .btn-right-2 {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n  text-transform: none;\r\n  margin: 0;\r\n  margin-left: 8px;\r\n}\r\n.modal-user .modal-footer-bottom-2 .btn-right-1 {\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n  text-transform: none;\r\n}\r\n.modal-user .modal-footer-bottom-2 .btn-right {\r\n  float: right;\r\n  margin-top: 7px;\r\n}\r\n.modal-user .modal-footer-bottom .modal-error-text {\r\n  padding-top: 7px;\r\n  font-weight: normal;\r\n  font-size: 13px;\r\n  line-height: 14px;\r\n  display: block;\r\n  margin-right: 90px;\r\n}\r\n.modal-user .modal-footer-bottom button {\r\n  height: 32px;\r\n  line-height: 32px;\r\n  font-size: 1rem;\r\n  position: absolute;\r\n  top: 9px;\r\n  right: 30px;\r\n}\r\n.modal-user .modal-footer-bottom,\r\n.modal-user .modal-footer-bottom-2 {\r\n  position: absolute;\r\n  bottom: 0px;\r\n  width: 100%;\r\n  height: 50px;\r\n  padding: 0px 25px;\r\n  border-top: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n.modal-user-footer .text-error {\r\n  padding: 25px;\r\n}\r\n.modal-user-footer .modal-content {\r\n  padding: 0px;\r\n}\r\n.modal-user .modal-content-outer {\r\n  position: absolute;\r\n  height: calc(100% - 50px);\r\n  width: 100%;\r\n  bottom: 50px;\r\n  overflow-y: auto;\r\n  padding: 15px 25px;\r\n}\r\n.modal-close i {\r\n  font-size: 2rem;\r\n}\r\n.modal-user .modal-content h4 {\r\n  display: none;\r\n}\r\n.modal-user .modal-footer .header {\r\n  font-size: 1.3rem;\r\n  padding: 0 25px;\r\n  height: 50px;\r\n  line-height: 50px;\r\n  float: left;\r\n  text-transform: uppercase;\r\n  font-weight: 600;\r\n}\r\n.modal-user .modal-close {\r\n  margin: 8px 0px;\r\n}\r\n.modal-user .modal-content {\r\n  position: absolute;\r\n  height: calc(100% - 50px);\r\n  max-height: 100%;\r\n  width: 100%;\r\n  top: 50px;\r\n  overflow-y: auto;\r\n}\r\n.modal-user .modal-footer {\r\n  position: absolute;\r\n  top: 0;\r\n  height: 50px;\r\n  padding: 0px;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.1);\r\n}\r\n.modal-user {\r\n  max-width: 850px;\r\n  border-radius: 16px;\r\n  width: 85%;\r\n  height: 70%;\r\n  /*height: 50% !important;*/\r\n  border: 3px solid #37bdb0;\r\n  max-height: 500px;\r\n}\r\n.content-req .title,\r\n.content-req .desc {\r\n  line-height: 18px;\r\n  min-height: 33px;\r\n  height: auto;\r\n}\r\n.text-error {\r\n  color: red;\r\n  font-size: 14px;\r\n}\r\n#table-total {\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n  text-transform: uppercase;\r\n  margin-bottom: 20px;\r\n}\r\n#table-alluser .btn-check i {\r\n  font-size: 2rem;\r\n}\r\n#table-alluser .btn-delete i {\r\n  font-size: 2.2rem;\r\n}\r\n#table-alluser .btn-delete {\r\n  display: inline-block;\r\n  padding-left: 7px;\r\n  padding-right: 7px;\r\n}\r\n#table-alluser .btn-edit i {\r\n  font-size: 2rem;\r\n}\r\n#table-alluser .btn-edit {\r\n  display: inline-block;\r\n  padding-left: 7px;\r\n  padding-right: 7px;\r\n}\r\n#table-alluser .btn-view i {\r\n  margin-top: 2px;\r\n  margin-bottom: 2px;\r\n  font-size: 24px;\r\n  line-height: unset;\r\n  display: inline;\r\n  color: #fff;\r\n}\r\n#table-alluser .btn-view {\r\n  border: 1px solid #ddd;\r\n  border-radius: 5px;\r\n  display: inline-block;\r\n  margin: 0 auto;\r\n  padding: 0px 5px;\r\n  background: #4f4949;\r\n  height: 35px;\r\n}\r\n#table-alluser .OK {\r\n  border: 2px solid #fb8c00;\r\n  background-color: #fb8c00;\r\n  color: #fff;\r\n}\r\n#table-alluser .PD,\r\n#table-alluser .RQ {\r\n  border: 2px solid #fb8c00;\r\n  background-color: #fff;\r\n  color: #fb8c00;\r\n}\r\n#table-alluser .CC {\r\n  border: 2px solid #f23030;\r\n  background-color: #fff;\r\n  color: #f23030;\r\n}\r\n#table-alluser .N {\r\n  border: 2px solid #726868;\r\n  background-color: #fff;\r\n  color: #726868;\r\n}\r\n#table-alluser .Y {\r\n  border: 2px solid #6ed8bd;\r\n  background-color: #6ed8bd;\r\n  color: #fff;\r\n}\r\n#table-alluser .active-text {\r\n  border-radius: 12px;\r\n  padding: 2px 0px;\r\n  font-size: 13px;\r\n  font-weight: 500;\r\n  max-width: 110px;\r\n  margin: 0 auto;\r\n}\r\n#table-alluser .total {\r\n  color: #20a684;\r\n}\r\n#table-alluser .small-text {\r\n  display: block;\r\n  font-size: 11px;\r\n  color: #20a684;\r\n}\r\n#table-alluser .text {\r\n  display: block;\r\n  font-size: 13px;\r\n}\r\n#table-alluser th,\r\n#table-alluser td {\r\n  text-align: center;\r\n  vertical-align: top;\r\n}\r\n#main-content .title {\r\n  text-transform: uppercase;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n}\r\n#main-content {\r\n  padding: 15px 20px;\r\n}\r\n.top-sub-bottom #btn-request-compensation {\r\n  float: right;\r\n  background: #fff;\r\n  border: 2px solid #26a69a;\r\n  color: #26a69a;\r\n  text-transform: none;\r\n  line-height: 30px;\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n  margin-left: 12px;\r\n}\r\n.top-sub-bottom #btn-create-new {\r\n  float: right;\r\n  text-transform: none;\r\n  line-height: 30px;\r\n  padding-left: 8px;\r\n  padding-right: 8px;\r\n  margin-left: 0px;\r\n}\r\n.top-sub-bottom div:nth-child(2) {\r\n  float: left;\r\n  margin-right: 15px;\r\n  line-height: 36px;\r\n}\r\n.top-sub-bottom div:nth-child(1) {\r\n  float: left;\r\n  margin-right: 15px;\r\n  line-height: 36px;\r\n}\r\n.top-sub-bottom .title {\r\n  font-weight: bold;\r\n  margin-right: 5px;\r\n}\r\n.top-sub-bottom {\r\n  padding: 0px 20px;\r\n}\r\n#top-sub-box-compensation {\r\n  background-color: #f1eee5;\r\n}\r\n#top-sub-box-balance {\r\n  background-color: #f2f0d5;\r\n}\r\n#top-sub-box-previous {\r\n  background-color: #ffd862;\r\n}\r\n#top-sub-box-annual {\r\n  background-color: #a6bf4b;\r\n}\r\n\r\n.top-sub-box .color-red {\r\n  color: #d40e0e;\r\n}\r\n\r\n.top-sub-box #top-sub-box-balance .text-day .sub-title {\r\n  display: inline-block;\r\n}\r\n\r\n.top-sub-box #top-sub-box-balance .text-hour .sub-title {\r\n  display: inline-block;\r\n}\r\n\r\n.top-sub-box .desc {\r\n  padding: 8px 0px;\r\n  font-size: 11px;\r\n}\r\n.top-sub-box .text-hour {\r\n  font-size: 11px;\r\n  margin-top: -6px;\r\n  height: 15px;\r\n}\r\n.top-sub-box .text-day {\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n}\r\n.top-sub-box span {\r\n  display: block;\r\n}\r\n.top-sub-box .textcolor-expired {\r\n  color: #e40d0d;\r\n}\r\n.top-sub-box .textcolor {\r\n  color: #000;\r\n}\r\n.top-sub-box div {\r\n  padding-top: 15px;\r\n  padding-bottom: 5px;\r\n  text-align: center;\r\n  border-radius: 12px;\r\n  margin: 0px;\r\n}\r\n.btn {\r\n  text-transform: none !important;\r\n}\r\n.filter-input-field .label {\r\n  text-align: left;\r\n  display: block;\r\n  padding: 0 0.75rem;\r\n  color: #5a5a5a;\r\n}\r\n.filter-input-field.select .search {\r\n  height: auto;\r\n}\r\n.ui.selection.active.dropdown {\r\n  border-color: #26a69a !important;\r\n}\r\n.ui.selection.active.dropdown .menu {\r\n  border-color: #26a69a !important;\r\n}\r\n.ui.label {\r\n  background-color: #eaeaea !important;\r\n}\r\n.ui.disabled.search {\r\n  opacity: 0.75 !important;\r\n}\r\n.ui.fluid.dropdown {\r\n  display: inline-block !important;\r\n}\r\n.alluser-dropdown.ui.selection.dropdown {\r\n  padding-top: 4px !important;\r\n  padding-bottom: 4px !important;\r\n}\r\n\r\n\r\n/* .dropdown-menu-max-height {\r\n  max-height: 200px;\r\n  overflow-y: auto;\r\n} */\r\n\r\n.menu-scrollable {\r\n    max-height: 120px;\r\n    overflow-y: auto;\r\n}\r\n\r\n\r\n  \r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
